import React, { useEffect } from 'react';
import { bool, func, instanceOf } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import omit from 'lodash/omit';
import cloneDeep from 'lodash/cloneDeep';
// import axios from 'axios';

import TargetMainHeader from './TargetMainHeader';
import CampaignTargets from '../CampaignTargets';
import {
  getDeDefinitions,
  setSelectedTargets,
  setDeCTTableQuery,
} from '../../../../actions/deActions/deTargetDashboardActions';
import * as urls from '../../../../actions/urlTypes';
import { exportTarget, setActiveTargetToLabel } from '../../../../actions/deActions/deLabelActions';
import { setTargetDistribute } from '../../../../actions/deActions/deDistributeActions';
import { deleteTarget } from '../../../../actions/deActions/deTargetDashboardActions';
import { setEditTargetDataForBuild } from '../../../../actions/deActions/deBuildActions';

const TargetDashboard = ({ setView, router, internalAdmin }) => {

  const dispatch = useDispatch();

  const { definition, accountId } = useSelector(
    ({ deTargetDashboard, account, login }) => {
      return {
        definition: {
          ...deTargetDashboard.definition,
          data: deTargetDashboard.definition.response.data,
        },
        accountId: account.activeAccountId,
        uid: login.loginResponse.data.uid,
      };
    }
  );

  useEffect(() => {
    dispatch(getDeDefinitions(accountId, definition.query));
  }, []);

  useEffect(() => {
    return () => dispatch(setDeCTTableQuery({
      searchText: '',
      sortBy: 'updts',
      sortOrder: 'desc',
      pageNo: 1,
    },));
  }, []);

  const handleAction = (actionType, target) => {
    if (actionType === 'Label') {
      dispatch(setActiveTargetToLabel(target));
      router.push(`${urls.APP_ROOT_URL}/datahub/label/${target.id}`)
    } else if (actionType === 'Distribute') {
      dispatch(setTargetDistribute(target));
      router.push(`${urls.APP_ROOT_URL}/datahub/distribute`)
    } else if (actionType === 'Export') {
      dispatch(exportTarget(target));
    } else if (actionType === 'Edit') {
      // function for Edit
      dispatch(setEditTargetDataForBuild(target));
      setTimeout(() => {
        router.push(`${urls.APP_ROOT_URL}/datahub/build`);
      }, 100);
    } else if (actionType === 'Duplicate') {
      const t = cloneDeep(target)
      const updatedTarget = omit(t, 'id');
      const copyTarget = { ...updatedTarget, name: `Copy_${updatedTarget.name}` };
      dispatch(setEditTargetDataForBuild(copyTarget));
      setTimeout(() => {
        router.push(`${urls.APP_ROOT_URL}/datahub/build`);
      }, 100);
    } else if (actionType === 'Delete') {
      const reqParam = { id : target.id };
      dispatch(deleteTarget(reqParam));
    }else {
      // functionality for Delete 
    }
  };

  const _updateQueryParams = (value, queryAttr, isLoadMore = false) => {
    let updatedQuery = { ...definition.query };
    if (queryAttr === 'sort') {
      updatedQuery = {
        ...updatedQuery,
        sortBy: value.sortBy,
        sortOrder: value.sortOrder,
        pageNo: 1,
      };
    } else if (queryAttr === 'searchText') {
      updatedQuery = {
        ...updatedQuery,
        sortBy: 'updts',
        sortOrder: 'desc',
        [queryAttr]: encodeURIComponent(value),
        pageNo: 1,
      };
    } else {
      updatedQuery = {
        ...updatedQuery,
        [queryAttr]: value,
      };
    }
    dispatch(getDeDefinitions(accountId, updatedQuery, isLoadMore));
  };

  const loadItems = page => {
    _updateQueryParams(page, 'pageNo', true);
  };

  return (
    <div className="de--main de--target de--flex-col de-o-hidden de--main-pad de--dashboard">
      <TargetMainHeader
        setView={setView}
        definition={{
          loading: definition.loading,
          data: definition.data,
          hasDefinition: definition.hasDefinition,
        }}
        data-test="TargetMainHeader"
      />
      <CampaignTargets
        definition={definition}
        setSelectedTargets={(checkSate, row) => dispatch(setSelectedTargets(checkSate, row))}
        updateQueryParams={_updateQueryParams}
        loadMore={loadItems}
        setView={setView}
        handleAction={handleAction}
        data-test="CampaignTargets"
        internalAdmin={internalAdmin}
      />
    </div>
  );
};

TargetDashboard.propTypes = {
  setView: func,
  router: instanceOf(Object),
  internalAdmin: bool
};

export default withRouter(TargetDashboard);
